import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { getCompanyConfig } from '@/config/company'

// 不带端口的域名，避免 localhost:8080 这类导致匹配失败
let host = window.location.hostname.replace("www.", "");
const companyData = getCompanyConfig(host)
let templeteIndex = parseInt(Math.random()*3+ 1)

if(host == 'yukekj.cn'){
  templeteIndex =  1
}
else if(host == 'yunzhengxx.cn'){
  templeteIndex =  3
}
else if(host == 'chenxixx.cn'){
  templeteIndex =  2
} else if (host == 'yyqkj.top') {
  templeteIndex =  1
}
export default createStore({
  state: {
    // 统一配置的公司信息：初始化时就从配置读取
    companyName: companyData.companyName || '',
    record_num: companyData.record_num || '',
    email: companyData.email || '',
    address: companyData.address || '',
    intro: companyData.intro || '',
    title: companyData.title || companyData.companyName || '',
    templateIndex:templeteIndex,
    menuIndex:0,
    icon:`https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/logo_${'0'+(host == 'yyqkj.top' ? 1 : parseInt(Math.random()*8+1))}%402x.png`
  },
  getters: {
  },
  mutations: {
    setCompany(state, payload) {
      const data = payload || {}
      // 统一从配置里来的字段，避免在 store 内再次硬编码覆盖
      state.companyName = data.companyName || data.title || ''
      state.record_num = data.record_num || ''
      state.email = data.email || ''
      state.address = data.address || ''
      state.intro = data.intro || ''
      // title 与公司名保持一致，避免页面读 title 时出现“非统一配置”
      state.title = state.companyName
    },
    setMenuIndex(state, payload){
      state.menuIndex = payload
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({storage:window.sessionStorage})]
})
